var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"vetroConn"}},[_c('b-input-group',{attrs:{"size":"md","prepend":"Token"}},[_c('b-input',{attrs:{"type":"token","autocomplete":"false","disabled":_vm.isReadonly},model:{value:(_vm.connection.token),callback:function ($$v) {_vm.$set(_vm.connection, "token", $$v)},expression:"connection.token"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54889a36","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/connection/VetroConnection.vue
// module id = null
// module chunks = 